const localStorageEnable =
  window.Storage &&
  window.localStorage &&
  window.localStorage instanceof Storage;
const localUser = localStorageEnable && localStorage.getItem('userH5');
const localCustomer = localStorageEnable && localStorage.getItem('userH5');
let userH5: any = {};
let customer: any = {};
try {
  userH5 = localStorageEnable && localUser ? JSON.parse(localUser) : {};
  customer =
    localStorageEnable && localCustomer ? JSON.parse(localCustomer) : {};
} catch (e) {}

export default {
  state: {
    userH5,
    customer
  },
  mutations: {
    setUser: (state: any, userH5: any) => {
      Object.assign(state.userH5, userH5);
      localStorageEnable &&
        localStorage.setItem('userH5', JSON.stringify(state.userH5));
    },
    setCustomer: (state: any, customer: any) => {
      Object.assign(state.customer, customer);
      localStorageEnable &&
        localStorage.setItem('customer', JSON.stringify(state.customer));
    },
    clearUser: (state: any) => {
      if (localStorageEnable) {
        localStorage.removeItem('userH5');
      }
      state.userH5 = {};
    }
  }
};
